<!-- TID Generator -->
@if(generatorType==='DefaultTIDGenerator') {
  <p-dialog [(visible)]="caisServiceService.isDisplayTIDGenerator" header="TID Generator" styleClass="quick-view-grid-row y-hidden" icon="pi pi-exclamation-triangle"
      width="425" width="425" appendTo="body" showEffect="fade" [modal]="true" (onHide)="caisServiceService.isDisplayTIDGenerator = false;userPreEncoded='';userPostEncoded='';">
    <div class="col-lg-12">
      <div class="col-lg-2 text-right"></div>
      <div class="col-lg-9"><span class="instrucitonText">For SSN, the format is 999-99-9999 (with dashes)</span></div>
    </div>
    <div class="col-lg-12">&nbsp;</div>
    <div class="col-lg-12">
      <div class="col-lg-2 text-right" [ngClass]="(this.caisServiceService.isLegalEntityForeignTIDGenerator || this.caisServiceService.isNaturalPersonForeignTIDGenerator) ? 'tid_lable' : ''"><label for="ID">{{(this.caisServiceService.isLegalEntityForeignTIDGenerator || this.caisServiceService.isNaturalPersonForeignTIDGenerator) ? "Foreign ID" :"ID"}}</label></div>
      <div class="col-lg-9">
        <input class="maxWidth" pInputText [id]="'userPreEncodedInput'" [name]="'userPreEncodedInput'" [(ngModel)]="userPreEncoded" placeholder="Enter Value" />
      </div>
      <div class="col-lg-1"></div>
    </div>
    <div class="col-lg-12">&nbsp;</div>
    <div class="col-lg-12">
      <div class="col-lg-2 text-right" [ngClass]="(this.caisServiceService.isLegalEntityForeignTIDGenerator || this.caisServiceService.isNaturalPersonForeignTIDGenerator) ? 'tid_lable' : ''"><label for="TID">TID</label></div>
      <div class="col-lg-9">
        <div class="ui-inputgroup">
          <input #userPostEncodedInput class="maxWidth" pInputText [id]="'userPostEncodedInput'" [name]="'userPostEncodedInput'" [(ngModel)]="userPostEncoded" placeholder="Encrypted Sha-256 Value" readonly />
        </div>
      </div>
      <div class="col-lg-1 float-left nopadding">
        <p-button id = "tid-copy-button" class="pi pi-xxx" or class="fa fa-xxx" class="iconBtn" matTooltip="Copy TID"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-copy" (click)="copytoClipboard(userPostEncodedInput)"></p-button>
      </div>
    </div>
    <div class="col-lg-12">&nbsp;</div>
    <div class="col-lg-12 text-center">
      <button type="button" class="btn btn-primary btn-md dialogBtn tid-gen-form--button btn-DodgerBlue" id="TIDReset" (click)="userPreEncoded='';userPostEncoded='';">
        Reset
      </button>&nbsp;
      <button type="button" class="btn btn-primary btn-md dialogBtn tid-gen-form--button btn-DodgerBlue" id="TIDGenerator" (click)="generateTID();">
        Generate
      </button>&nbsp;
      @if(this.caisServiceService.isLegalEntityForeignTIDGenerator){
      <button type="button" class="btn btn-primary btn-md dialogBtn tid-gen-form--button btn-DodgerBlue" id="TIDSave" (click)="saveTID('LegalEntity');">
        Save
      </button>
      }
      @if(this.caisServiceService.isNaturalPersonForeignTIDGenerator){
      <button type="button" class="btn btn-primary btn-md dialogBtn tid-gen-form--button btn-DodgerBlue" id="TIDSave" (click)="saveTID('NaturalPerson');">
        Save
      </button>
      }
    </div>
  </p-dialog>
} @else if(generatorType==='formTIDGenerator') {
  <!-- TID Generator Add/Edit Form -->
    <form [formGroup]="tidGenerationForm">
      <span [ngClass]="'zindex ui-g-12 ui-md-12 ui-lg-6'">
        <span>
          <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
            <div [ngClass]="'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg'">
              <label for="ui_Field_Name">
                {{tidGeneratorFieldLabel}}
              </label>
            </div>
            <div [ngClass]="'ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg'">
              <p-toggleswitch [id]="'tid_generator_switch'" formControlName="tid_generator_switch"></p-toggleswitch>
            </div>
            <div [ngClass]="'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
              <span>
                <ng-container>
                  @if(needOfMaskField) {
                    <p-inputMask [id]="'tid_generator_input'" class="maxWidth" 
                      formControlName="tid_generator_input" [mask]="tidGeneratorMask" [placeholder]="tidGeneratorMask" [autoClear]="false"></p-inputMask>
                  } @else {
                    <input pInputText [id]="'tid_generator_input'" class="maxWidth" [maxlength]="maxLength"
                      [ngClass]="(tidGenerationForm.get('tid_generator_input')?.value && tidGenerationForm.get('tid_generator_input')?.invalid) ? 'errorField' : ''"
                      formControlName="tid_generator_input" [placeholder]="tidGeneratorMask">
                  }
                </ng-container>
              </span>
            </div>
            <div [ngClass]="'ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg'">
              <span>
                <ng-container>
                  <p-button type="button" icon="fa fa-long-arrow-right" [id]="'tid_apply'" [disabled]="enableTIDGenerateBtn(tidGenerationForm.get('tid_generator_input'))" 
                    (click)="generateAndPrepareTID(userType, tidGenerationForm.get('tid_generator_input')?.value);" class="generateTidBtn"
                    matTooltip="Apply & Generate TID" matTooltipPosition="above" appendTo="body"></p-button>
                </ng-container>
              </span>
            </div>
          </div>
        </span>
      </span>
    </form>
} @else if(generatorType==='TIDGeneratorInstructions') {
  <!-- TID Generator Instructions -->
  <div class="ui-grid-col-12 container contents">
    <span [ngClass]="'zindex ui-g-12 ui-md-12 ui-lg-12'">
      <span>
        <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
          <div [ngClass]="'ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg'">
            <span class="instrucitonText"><strong class="error-mark">* </strong>RSMS does not log OR save any Tax Id</span>
          </div>
        </div>
      </span>
    </span>
  </div>
}